export default {
      id: "ic-soc-pinterest-usage",
      viewBox: "0 0 26 26",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#ic-soc-pinterest-usage",
      toString: function () {
        return this.url;
      }
    }